import Vue from "vue";
import VueRouter from "vue-router";

import routes from "./routes";

Vue.use(VueRouter);

const router = new VueRouter({
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes,
  // Leave these as is and change from quasar.conf.js instead!
  // quasar.conf.js -> build -> vueRouterMode
  // quasar.conf.js -> build -> publicPath
  mode: "hash",
  base: process.env.VUE_ROUTER_BASE
});
// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     if (router.app.$keycloak.authenticated) {
//       next();
//     } else {
//       const loginUrl = router.app.$keycloak.createLoginUrl();
//       window.location.replace(loginUrl);
//     }
//   } else {
//     next();
//   }
// });
export default router;
